var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPri(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 19.0002H17.398",
    stroke: "#205A46",
    style: (_ref2 = {
      stroke: "#205A46"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1255 0.3529 0.2745)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.897 2.49694L12.5648 1.82914C12.8277 1.56623 13.1399 1.35769 13.4835 1.21542C13.8271 1.07316 14.1953 0.999958 14.5671 1C14.939 1.00004 15.3072 1.07333 15.6507 1.21567C15.9943 1.35801 16.3064 1.56662 16.5693 1.82959C16.8322 2.09257 17.0408 2.40475 17.183 2.74832C17.3253 3.09188 17.3985 3.46011 17.3985 3.83196C17.3984 4.20382 17.3251 4.57203 17.1828 4.91556C17.0405 5.2591 16.8318 5.57123 16.5689 5.83414L15.9011 6.50014M11.897 2.49694C11.897 2.49694 11.9807 3.91535 13.2317 5.16635C14.4827 6.41735 15.9011 6.50014 15.9011 6.50014M11.897 2.49694L5.76167 8.63224C5.34587 9.04804 5.13797 9.25504 4.95977 9.48454C4.74868 9.75462 4.56789 10.0471 4.42067 10.3566C4.29557 10.6185 4.20287 10.8975 4.01657 11.4546L3.22907 13.818M15.9011 6.50014L9.76577 12.6363C9.34997 13.0521 9.14297 13.2591 8.91347 13.4382C8.64287 13.6494 8.35217 13.8291 8.04137 13.9773C7.77947 14.1024 7.50047 14.1951 6.94337 14.3805L4.57997 15.1689M3.22907 13.818L3.03737 14.3949C2.99244 14.5295 2.98587 14.6738 3.01841 14.8119C3.05094 14.9499 3.1213 15.0762 3.22158 15.1764C3.32187 15.2767 3.44811 15.3471 3.58615 15.3796C3.72418 15.4121 3.86856 15.4056 4.00307 15.3606L4.57997 15.1689M3.22907 13.818L4.57997 15.1689",
    stroke: "#205A46",
    style: (_ref3 = {
      stroke: "#205A46"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1255 0.3529 0.2745)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.35
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPri);
export default __webpack_public_path__ + "static/media/editPri.be717444.svg";
export { ForwardRef as ReactComponent };